import useDarkMode from '@rio-cloud/rio-uikit/hooks/useDarkMode';
import { FormattedMessage } from 'react-intl';

import {
  Container,
  Heading,
  ImageContainer,
  Text,
  TextContainer} from "@/components/organism/NewFeaturesSection/NewFeaturesSection.styles";
import { getLocale } from '@/configuration/lang/langSlice';
import { useAppSelector } from '@/configuration/setup/hooks';

const texts = {
  title: 'getStartedPage.newFeaturesSection.title',
  description: 'getStartedPage.newFeaturesSection.description',
  howItWorksLabel: 'getStartedPage.howVirtualAssistantWorks.label',
  features: [
    'getStartedPage.newFeaturesSection.partOne',
    'getStartedPage.newFeaturesSection.partTwo',
    'getStartedPage.newFeaturesSection.partThree',
    'getStartedPage.newFeaturesSection.partFour',
    'getStartedPage.newFeaturesSection.partFive',
  ],
};

const NewFeaturesSection = () => {
  const isDarkMode = useDarkMode();
  const currentLanguage = useAppSelector(getLocale);

  return (
    <Container $isdarkmode={isDarkMode}>
      <TextContainer>
        <Heading $isdarkmode={isDarkMode}>
          <FormattedMessage id={texts.title} />
        </Heading>
        <Text $isdarkmode={isDarkMode}>
          <FormattedMessage id={texts.description} />
          <ul className="margin-top-5">
            {texts.features.map((feature, index) => (
              <li key={`feature-li-${index}`}>
                <div key={`feature-div-${index}`}>
                  <span key={`feature-span-${index}`}>
                    <FormattedMessage id={feature} key={`feature-${index}`} />
                  </span>
                </div>
              </li>
            ))}
          </ul>
        </Text>
      </TextContainer>
      <ImageContainer>
        <img
          src={currentLanguage === 'de-DE' ? 'assets/images/screenshot_de.png' : 'assets/images/screenshot_en.png'}
          alt=""
          height={200}
        />
      </ImageContainer>
    </Container>
  );
};

export default NewFeaturesSection;
